import { create } from "zustand";
import axios from "axios";

const useStatusStore = create((set) => ({
    deliveryAvailable: false,
    orderAvailable: false,
    isInDeliveryTime: false,
    isInPickupTime: false,
    loading: false,
    error: null,

    fetchDeliveryAvailable: async () => {
        try {
            set({ loading: true, error: null });
            const response = await axios.get("/api/public/status/deliveryAvailable");
            set({ deliveryAvailable: response.data.deliveryAvailable, loading: false });
        } catch (error) {
            set({ error: "Error fetching delivery availability", loading: false });
        }
    },

    fetchOrderAvailable: async () => {
        try {
            set({ loading: true, error: null });
            const response = await axios.get("/api/public/status/orderAvailable");
            set({ orderAvailable: response.data.orderAvailable, loading: false });
        } catch (error) {
            set({ error: "Error fetching order availability", loading: false });
        }
    },

    fetchIsInDeliveryTime: async () => {
        try {
            set({ loading: true, error: null });
            const response = await axios.get("/api/public/status/inDeliveryTime");
            set({ isInDeliveryTime: response.data.inDeliveryTime, loading: false });
        } catch (error) {
            set({ error: "Error checking delivery time", loading: false });
        }
    },

    fetchInPickupTime: async () => {
        try {
            set({ loading: true, error: null });
            const response = await axios.get("/api/public/status/inPickupTime");
            set({ isInPickupTime: response.data.inPickupTime, loading: false });
        } catch (error) {
            set({ error: "Error checking pickup time", loading: false });
        }
    },
}));

export default useStatusStore;
